import { actionTypes } from '../../constants/actionTypes';
import { IStickHeaderState, TReduxActions } from '../../types/redux';

const defaultState = {
  isVisible: false,
};

export function stickHeaderReducer(state: IStickHeaderState = defaultState, action: TReduxActions) {
  switch (action.type) {
    case actionTypes.SET_VISIBLE_STICK_HEADER:
      return {
        isVisible: action.payload,
      };

    default:
      return state;
  }
}
